module.exports = __webpack_public_path__ + "img/Jump Casting120.31486568.jpg";